import { SquareMatrix } from './SquareMatrix';
export class SquareMatrix3D extends SquareMatrix {
    static identity() {
        // prettier-ignore
        return new SquareMatrix3D([
            1, 0, 0,
            0, 1, 0,
            0, 0, 1
        ]);
    }
    constructor(initialContents = []) {
        super(3, initialContents);
    }
}
//# sourceMappingURL=SquareMatrix3D.js.map